<template>
    <div class="resource-download">
        <div class="resource-list scrollbar">
            <div v-if="!resourceList || resourceList.length === 0" class="empty-resource">
                <img
                    src="@images/player/not-resourse.png"
                    alt="暂无资源"
                    class="empty-resouce-icon"
                />
                <div>暂无内容</div>
            </div>
            <resource
                v-for="(resource, index) in resourceList"
                :key="index"
                :name="resource.name"
                :type="resource.type"
                class="resource-item"
                @click="handleDownloadResource(resource.id)"
            ></resource>
        </div>
    </div>
</template>

<script>
import { downloadResource } from '@api/liveList';
import Resource from './Resource.vue';
export default {
    components: { Resource },
    props: {
        resourceList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        async handleDownloadResource(id) {
            const { data } = await downloadResource(id);
            window.open(data);
        }
    }
};
</script>

<style lang="scss" scoped>
.resource {
    &-download {
        position: relative;
        height: 100%;
    }
    &-list {
        padding: 0 17px;
        position: absolute;
        top: 0;
        bottom: 10px;
        left: 0;
        right: 0;
    }
    &-item {
        margin: 12px 0;
    }
}
.empty-resource {
    text-align: center;
    font-weight: 500;
    color: #666666;
    line-height: 24px;
    &-icon {
        width: 95px;
        height: 113px;
    }
}
</style>
